import React, { Component } from 'react';
import { Table, TableHead, TableRow, TableBody, TableCell, Box, IconButton } from '@mui/material';
import Dialog from '../../../common/Dialog';
import { isEmpty, uniqBy } from 'lodash';
import { green, red } from '@mui/material/colors';
import { PrintRounded } from '@mui/icons-material';

class PrintRefs extends Component {
    state = { 
        list: []
    }
    componentDidMount = () => {
        let list = this.props.type === "vehicule" ? uniqBy(Object.values(this.props.VEHICULES), "equipement_original_name") : uniqBy(Object.values(this.props.EQUIPEMENTS), "equipement_original_name")
        // list = this.props.type === "vehicule" ? list.filter(i => i.equipement_type !== "vehicule") : list.filter(i => i.equipement_type === "vehicule")

        this.setState({list})
    }
    render() {
        const {EQUIPEMENTS, LOCALISATIONS} = this.props;
        return (
            <Dialog
                maxWidth="lg"
                close={this.props.closePrint}
                title="Liste des références"
                secondaryAction={<IconButton onClick={() => window.print()} color="primary"><PrintRounded /></IconButton>}
                appBar
            >
                <Box id="section-to-print">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Photo</TableCell>
                                <TableCell>Intitulé</TableCell>
                                <TableCell>Référence</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>Localisation</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(this.state.list) && !isEmpty(LOCALISATIONS.CHILD) && this.state.list.map(equipement =>
                                <TableRow 
                                    // style={{ backgroundColor: (equipement.equipement_available ? green[50] : red[50]) }}   
                                    key={equipement.equipement_original_name} 
                                >
                                    <TableCell>
                                        <img 
                                            // style={{opacity: ".7"}}
                                            style={{maxHeight: "200px"}}
                                            src={`/photos/single/${equipement[`equipement_photo_front`].filename}`} 
                                            title={equipement.equipement_original_name}
                                            alt={equipement.equipement_original_name}
                                        />
                                    </TableCell>
                                    <TableCell><b>{equipement.equipement_original_name}</b></TableCell>
                                    <TableCell><b>{equipement.equipement_ref}</b></TableCell>
                                    <TableCell><b>{equipement.equipement_quantity}</b></TableCell>
                                    <TableCell>
                                        {LOCALISATIONS.CHILD[equipement.equipement_localisation] && LOCALISATIONS.CHILD[equipement.equipement_localisation].loc_name}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>

            </Dialog>
        );
    }
}

export default PrintRefs;